module.exports = __webpack_public_path__ + "media/images/icons/twitter-dark-09c9417e7bf18995b19c69188476cdf5.png";